import { css } from '@emotion/react';
import themes from './themes/standard';

const base = css`
    html,
    body {
        padding: 0;
        margin: 0;
        font-family: ${themes.fonts.gtWalsheimProRegular};
        font-size: 14px;
        height: 100%;
    }

    * {
        transition: color 0.3s ease, background-color 0.3s ease;
    }

    button {
        font-family: ${themes.fonts.gtWalsheimProRegular};
        :hover {
            cursor: pointer;
        }
    }

    body {
        background: #f4f4f4;
        display: flex;
        min-height: 100vh;
        height: 100%;
        flex-direction: column;
        -webkit-text-size-adjust: 100%;
    }

    #react-root {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    #root {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .grow-container {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .App {
        background: #ffffff;
        flex: 1;
        display: flex;
        flex-direction: column;

        > * {
            flex: 1 1 auto;
            width: 100%;
        }

        &[data-has-header='true'] {
            @media (max-width: 1023px) {
                margin-top: 139px;
            }
        }
    }

    strong {
        font-family: 'Sky Medium';
    }

    .sba-open body {
        @media (min-width: 1024px) {
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
    }
`;

export default base;
